import {zodResolver} from '@hookform/resolvers/zod'
import {useMutation, useQuery} from '@apollo/client'
import {useForm} from 'react-hook-form'
import {
  DELETE_DILIGENCIA_HISTORICO,
  PUT_DILIGENCIA_HISTORICO,
  SET_DILIGENCIA_HISTORICO,
} from '../mutations/diligencia-historico'
import {
  putDiligenciaHistoricoFormData,
  putDiligenciaHistoricoFormSchema,
  setDiligenciaHistoricoFormData,
  setDiligenciaHistoricoFormSchema,
} from '../formValidations/DiligenciaHistorico'
import {
  TypesDeleteDiligenciaHistoricoResponse,
  TypesGetDiligenciaHistoricoByIDResponse,
  TypesGetDiligenciaHistoricoResponse,
  TypesPutDiligenciaHistoricoResponse,
  TypesSetDiligenciaHistoricoResponse,
} from '../type/diligencia-historico'
import {
  GET_DILIGENCIA_HISTORICO,
  GET_DILIGENCIA_HISTORICO_BY_ID,
} from '../query/diligencia-historico'

interface QueryProps {
  variables: any
}

export function QueryGetDiligenciaHistorico({variables}: QueryProps) {
  const {data, loading, error, refetch} = useQuery<TypesGetDiligenciaHistoricoResponse>(
    GET_DILIGENCIA_HISTORICO,
    {
      variables: {...variables},
    }
  )
  return {data, loading, error, refetch}
}

export function QueryGetDiligenciaHistoricoByID({variables}: QueryProps) {
  const {data, loading, error} = useQuery<TypesGetDiligenciaHistoricoByIDResponse>(
    GET_DILIGENCIA_HISTORICO_BY_ID,
    {
      variables: {...variables},
    }
  )
  return {data, loading, error}
}

export function MutationCreateDiligenciaHistorico() {
  const {
    register,
    handleSubmit,
    formState: {errors},
  } = useForm<setDiligenciaHistoricoFormData>({
    resolver: zodResolver(setDiligenciaHistoricoFormSchema),
  })

  const [setDiligenciaHistoricoBody, {error, loading, data: DataSetDiligenciaHistorico}] =
    useMutation<TypesSetDiligenciaHistoricoResponse>(SET_DILIGENCIA_HISTORICO)

  async function FormDiligenciaHistorico(data: setDiligenciaHistoricoFormData) {
    return await setDiligenciaHistoricoBody({
      variables: {
        diligenciaHistorico: {...data},
      },
      refetchQueries: [GET_DILIGENCIA_HISTORICO],
    })
  }

  return {
    register,
    handleSubmit,
    FormDiligenciaHistorico,
    loading,
    errors,
    error,
    DataSetDiligenciaHistorico,
  }
}

export function MutationPutDiligenciaHistorico() {
  const {
    register,
    handleSubmit,
    formState: {errors},
  } = useForm<putDiligenciaHistoricoFormData>({
    resolver: zodResolver(putDiligenciaHistoricoFormSchema),
  })

  const [putDiligenciaHistoricoBody, {error, loading, data: DataPutDiligenciaHistorico}] =
    useMutation<TypesPutDiligenciaHistoricoResponse>(PUT_DILIGENCIA_HISTORICO)

  async function FormDiligenciaHistorico(data: putDiligenciaHistoricoFormData) {
    return await putDiligenciaHistoricoBody({
      variables: {
        diligenciaHistorico: {...data},
      },
      refetchQueries: [GET_DILIGENCIA_HISTORICO, GET_DILIGENCIA_HISTORICO_BY_ID],
    })
  }

  return {
    register,
    handleSubmit,
    FormDiligenciaHistorico,
    loading,
    errors,
    error,
    DataPutDiligenciaHistorico,
  }
}

export function MutationDeleteDiligenciaHistorico() {
  const [deleteDiligenciaHistorico, {loading, data, error}] =
    useMutation<TypesDeleteDiligenciaHistoricoResponse>(DELETE_DILIGENCIA_HISTORICO)

  async function HandleDeleteDiligenciaHistorico({variables}: QueryProps) {
    try {
      const result = await deleteDiligenciaHistorico({
        variables: {...variables},
        refetchQueries: [GET_DILIGENCIA_HISTORICO],
      })
      return result
    } catch (e) {
      if (e) {
        return false
      }
    }
  }

  return {HandleDeleteDiligenciaHistorico, loading, error, data}
}
